import React, { useEffect, useState } from "react";
import {
  DocumentData,
  QueryDocumentSnapshot,
  QuerySnapshot,
  collection,
  getDocs,
  orderBy,
  getFirestore,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";

import { ConnectionRequestPost } from "../Types/connectionRequests";
import { NewUserProfileType } from "../Types/userProfile";
import AddConnectionsPost from "./AddConnectionsPost";
import { app, auth } from "../lib/firebase";
import "../lib/RequireUser/index.css";

import { getStorage, ref } from "firebase/storage";

const db = getFirestore(app);

function AddConnectionsPre() {
  const tempUser = localStorage.getItem("userUID");
  console.log("in addConnections and userUID = ", tempUser);

  const [userProfilesAll, setUserProfilesAll] = useState<NewUserProfileType[]>(
    []
  );
  const [thisUserProfile, setThisUserProfile] = useState<NewUserProfileType[]>(
    []
  );
  const [connectionRequestsAll, setConnectionRequestsAll] = useState<
    ConnectionRequestPost[]
  >([]);

  //query connectionReequestts documents
  const qConnectionRequests = query(collection(db, "connectionRequests"));

  //Load all connection requests
  useEffect(
    () =>
      onSnapshot(qConnectionRequests, (snapshot) => {
        setConnectionRequestsAll(
          snapshot.docs.map((doc) => {
            return {
              id: doc.id,
              ...doc.data(),
            };
          })
        );
      }),
    []
  );

  //query all userProfile and output only this user
  const qUser = query(
    collection(db, "userProfiles"),
    where("userUID", "==", tempUser)
  );

  //load only this user's profile
  useEffect(
    () =>
      onSnapshot(qUser, (snapshot) => {
        setThisUserProfile(
          snapshot.docs.map((doc) => {
            return {
              id: doc.id,
              ...doc.data(),
            };
          })
        );
      }),
    []
  );

  //query all userProfile but do not include this user
  const qUsersAll = query(
    collection(db, "userProfiles"),
    where("userUID", "!=", tempUser),
    orderBy("userProfileName", "desc")
  );

  useEffect(
    () =>
      onSnapshot(qUsersAll, (snapshot) => {
        setUserProfilesAll(
          snapshot.docs.map((doc) => {
            return {
              id: doc.id,
              ...doc.data(),
            };
          })
        );
      }),
    []
  );

  //Create a temp user profile array
  let userProfiles = [];

  let i = 0,
    j = 0,
    k = 0,
    l = 0;
  let requestsArrayOK = 1;
  let userConnectionsOK = 1;

  console.log("length of userProfilesAll = ", userProfilesAll.length);
  console.log("length of thisUserProfile = ", thisUserProfile.length);
  //console.log("length of connectionRequestsAll = ", connectionRequestsAll.length);
  //console.log("useProfilesAll = ", userProfilesAll);
  //for each users
  //check if any userProfile[i].connection[j] has thisUser[0].userEmail i.e. they are already connected
  //check if any userProfile[i].userEmail has a connectionRequest[l].requestToEmail to thisUser[0].userEmail
  //check if thisUser[0].userEmail has a connectionRequest[l].requestFromEmail to thisUser[0].userEmail
  //if all the above are negative then userProfiles[l] = userProfilesAll[i]
  console.log("userProfilesAll.length", userProfilesAll.length);
  for (i = 0; i < userProfilesAll.length; i++) {
    let requestsArrayOK = 1;
    let userConnectionsOK = 1;
    for (j = 0; j < connectionRequestsAll.length; j++) {
      if (
        (connectionRequestsAll[j].requestFromEmail ===
          thisUserProfile[0].userEmail &&
          connectionRequestsAll[j].requestToEmail ===
            userProfilesAll[i].userEmail) ||
        (connectionRequestsAll[j].requestFromEmail ===
          userProfilesAll[i].userEmail &&
          connectionRequestsAll[j].requestToEmail ===
            thisUserProfile[0].userEmail)
      ) {
        requestsArrayOK = 0;
        //console.log(" requestsArrayOK = 0");
      }
      //console.log(" connection request j = ", j, " has requestFrom = ", connectionRequestsAll[j].requestFromEmail);
      //console.log(" connection request j = ", j, " has requestTo = ", connectionRequestsAll[j].requestToEmail);
      //console.log("this user email = ", thisUserProfile[0].userEmail);
      //console.log("for i = ", i, " user profile email of i = ", userProfilesAll[i].userEmail);
    }
    //console.log("i = ", i, " and requestsArrayOK = ", requestsArrayOK);
    console.log(
      "i = ",
      i,
      " and userProfilesAll[i].userConnections ",
      userProfilesAll[i].userConnections
    );
    for (k = 0; k < userProfilesAll[i].userConnections.length; k++) {
      //console.log("k = ", k, " and userConnections = ", userProfilesAll[i].userConnections[k]);
      if (
        userProfilesAll[i].userConnections[k] === thisUserProfile[0].userEmail
      ) {
        userConnectionsOK = 0;
        //console.log(" userConnectionsOK = 0 ");
      }
    }

    //console.log("i = ", i, " and userConnectionsOK = ", userConnectionsOK);
    if (requestsArrayOK === 1 && userConnectionsOK === 1) {
      userProfiles[l] = userProfilesAll[i];
      //console.log(" profile copied for i = ", i);
      l++;
    }
  }
  //console.log("userProfiles.length = ", userProfiles.length);

  return (
    <div>
      {userProfiles && userProfiles.length ? (
        <div>
          {userProfiles?.map((userProfiles) => (
            <AddConnectionsPost
              key={userProfiles.id}
              userProfile={userProfiles}
            />
          ))}
        </div>
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
}

export default AddConnectionsPre;
